import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=a2f6d90c&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f6d90c')) {
      api.createRecord('a2f6d90c', component.options)
    } else {
      api.reload('a2f6d90c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=a2f6d90c&", function () {
      api.rerender('a2f6d90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/components/Sidebar/Sidebar.vue"
export default component.exports